import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petitionGuidesCategory',
		path: '/petition-guides/category/:categorySlug',
		component: loadable(async () => import(/* webpackChunkName: "pages/petitionGuides-category-details" */ './index'), {
			exportName: 'PetitionGuidesCategory',
			fallback: Loading,
		}),
		frame: true,
		ssr: { enabled: true, seo: true },
	},
];
